export class ResendVerificationFakeDb {
  public static users = [];
}
